import { Box } from '@material-ui/core';
import { SinglePaymentStatus } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const SinglePaymentStatusLabel = ({ status }: { status: SinglePaymentStatus }) => {
  const { palette } = useCustomTheme();
  const getColorByStatus = (status: SinglePaymentStatus) => {
    switch (status) {
      case SinglePaymentStatus.CONFIRMED:
        return palette.success.main;
      case SinglePaymentStatus.PROCESSING:
        return palette.info.main;
      case SinglePaymentStatus.PENDING:
        return palette.info.dark;
      case SinglePaymentStatus.CANCELLED:
        return palette.grey[300];
      case SinglePaymentStatus.DENIED:
        return palette.error.main;
      default:
        return palette.grey[300];
    }
  };

  return (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gridGap={8}>
      <Box bgcolor={getColorByStatus(status)} height={14} width={14} borderRadius={7} />
      <Font variant={'body2'}>
        <Text tId={status} />
      </Font>
    </Box>
  );
};
